import {
  createActions, asyncInitialState, asyncSelectors
} from './../../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row })
}, 'whereUsedBOM');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  Columns: [
    { headerName: 'BOM code', field: 'BomCode', minWidth: 150, },
    { headerName: 'Quantity', field: 'QuantityDisplay', type: 'numericColumn', suppressSorting: true, minWidth: 150, },
    { headerName: 'Line', field: 'Line', type: 'numericColumn', suppressSorting: true, minWidth: 100, },
    { headerName: 'Description', field: 'Description', minWidth: 350, },
  ],
  Data: []
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.setSelected:
      const selected = action.data.row;

      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.inventoryEnquiry.whereUsed.whereUsedBOM,
  {
    data: data => data.Data,
    selected: data => data.selected,
  }
)

const syncSelector = {
  isLoading: state => state.inventoryEnquiry.whereUsed.whereUsedBOM.fetch_loading,
  columns: state => state.inventoryEnquiry.whereUsed.whereUsedBOM.data.Columns,
  gridOptions: state => state.inventoryEnquiry.whereUsed.whereUsedBOM.data.gridOptions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)